<template>
  <div class="southcargo">
    <m-title :titlelist="listitem"></m-title>
    <div class="ffcrgo_content">
      <div class="changdi">
        <span>货场名称</span>
        <div class="select_box">
          <el-select v-model="selectitem.stname" placeholder="请选择"  @input="changdiselect">
            <el-option v-for="it in changdisel" :key="it.value" :value="it.value" :label="it.label"></el-option>
          </el-select>
        </div>
      </div>
      <div class="ffcrgo_content_chart">
        <div class="chart_left">
          <div class="chart_left1">
            <div class="xian"></div>
            <div class="title">车辆作业数</div>
          </div>
          <div class="chart_left_view" ref="ltopview"></div>
        </div>
        <div class="chart_right">
          <div class="chart_left1">
            <div class="xian"></div>
            <div class="title">分时段车辆数</div>
          </div>
          <div class="chart_right_view" ref="rtopview"></div>
        </div>
      </div>
      <div class="ffcrgo_content_list">
        <div class="chart_left">
          <div class="chart_left1">
            <div class="xian"></div>
            <div class="title">计划列表(计划数:{{ tablelist.planCount }})</div>
          </div>
        </div>
        <div class="list_title">
          <div class="list_title_left">
            <span style="margin: 0 10px 0 20px">计划编号</span>
          <input
            type="text"
            v-model="selectitem.pno"
            placeholder="请填写计划编号"
          />
          <span>计划状态</span>
          <!-- <div class="select_box"> -->
            <el-select v-model="selectitem.status" placeholder="请选择"  style="width: 100px;">
              <el-option v-for="it in selectastrict" :key="it.value" :value="it.value" :label="it.label"></el-option>
            </el-select>
          <!-- </div> -->
          <!-- <span style="margin: 0 10px 0 20px">作业垛位</span>
          <div class="select_box">
            <m-select :list="selectastrictt" v-model="selectitem.stname"></m-select>
          </div> -->
          <span style="margin: 0 10px 0 20px">货主</span>
          <input
            type="text"
            v-model="selectitem.customname"
            placeholder="请输入"
            clearable
          />
          </div>
          
          <div class="title-btn">
            <button @click="selectlist">查询</button>
            <button class="button1" @click="reset">重置</button>
          </div>
          
        </div>
        <div class="list_content">
          <ul class="ulbox">
            <li
              class="item_style"
              v-for="item in tablelist.data"
              :key="item.id"
            >
                <div class="swipers">
                  <div class="swiperleft">
                    <div class="inquire">计划号：{{ item.pno }}</div>
                    <div class="point">{{ item.localhoststatus==0?'启用':"关闭" }}</div>
                  </div>
                  <el-switch
                    :value="item.localhoststatus==0?false:true"
                    active-color="#5288FF"
                    inactive-color="#ff4949"
                    @change="handleChange(item)"
                    class="strabs"
                  >
                  </el-switch>
                </div>
                <div class="list-content" @click="jumpdetails(item.pno)">
                  <div class="divbox">
                  <div class="box_title">类型:{{ item.plantypename }}</div>
                </div>
                <div class="divbox">
                  <div class="box_title">货主:{{ item.customname }}</div>
                </div>
                <div class="divbox">
                  <div class="box_title">货物来源：{{ item.agentname }}</div>
                </div>
                <div class="divbox">
                  <div class="box_title">作业垛位：{{ item.hwstr }}</div>
                </div>
                <div class="divbox">
                  <div class="box_title">
                    <span style="font-weight: 400; color: #666666"
                      >作业/计划 吨数</span
                    >:
                    <span
                      >{{ item.sumSullte/1000 ||0  }}/{{
                        item.plantons 
                      }}</span
                    >
                  </div>
                </div>
                <ul>
                  <li>
                    <span style="color: #FFC000" class="span"
                      >{{ item.auditCount?item.auditCount:0 }}</span
                    >
                    <span class="span1">等待审核</span>
                  </li>
                  <li>
                    <span style="color: #5288FF" class="span"
                      >{{ item.toStayInCount?item.toStayInCount:0 }}</span
                    >
                    <span class="span1">进场途中</span>
                  </li>
                  <li>
                    <span style="color: #17B6A1" class="span"
                      >{{ item.stayOutCount? item.stayOutCount:0}}</span
                    >
                    <span class="span1">场内作业</span>
                  </li>
                </ul>
                <div class="kx"></div>
                <div class="botline">
                  <div
                    style="float: left; height: 100%; width: 33.333333333333336%"
                  >
                    <span
                      class="baritemline"
                      :style="{
                        width: (item.auditCount / 10) * 100 + '%',
                        maxWidth: '100%',
                        background: '#17B6A1',
                      }"
                    ></span>
                  </div>
                  <div
                    style="float: left; height: 100%; width: 33.333333333333336%"
                  >
                    <span
                      class="baritemline"
                      :style="{
                        width: (item.toStayInCount / 10) * 100 + '%',
                        maxWidth: '100%',
                        background: '#4bd782',
                      }"
                    ></span>
                  </div>
                  <div
                    style="
                      float: left;
                      height: 100%;
                      width: 33.333333333333336%;
                    "
                  >
                    <span
                      class="baritemline"
                      :style="{
                        width: (item.stayOutCount / 10) * 100 + '%',
                        maxWidth: '100%',
                        background: '#ff5926',
                      }"
                    ></span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 分页 -->
        <div class="paging">
          <el-pagination
            :page-size="selectitem.limit"
            :current-page="selectitem.page"
            layout="total,prev, pager,next, jumper"
            :total="tablelist.planCount"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
      <div class="ffcrgo_content_table">
        <div class="chart_left">
          <div class="chart_left1">
            <div class="xian"></div>
            <div class="title">每日派车数量</div>
          </div>
        </div>
        <div class="content_table_list">
          <div class="itemsdev">
            <div class="deeps">
              <div class="listded">
                {{ everydaylist.date }}
              </div>
              <ul
                class="table_item"
                v-for="(item, index) in zeroToMorning"
                :key="index"
              >
                <li class="item">
                  <div class="amount">
                    <div class="iteml">{{ item.periodTime }}</div>
                  </div>
                  <span class="linet" style="color: #7A8294">{{
                    item.carNum
                  }}</span>
                </li>
              </ul>
            </div>
            <div class="deeps">
              <div class="listded">
                {{ everydaylist.date }}
              </div>
              <ul
                class="table_item"
                v-for="(item, index) in morningToNoon"
                :key="index"
              >
                <li class="item">
                  <div class="amount">
                    <div class="iteml">{{ item.periodTime }}</div>
                  </div>
                  <span class="linet" style="color: #7A8294">{{
                    item.carNum
                  }}</span>
                </li>
              </ul>
            </div>

            <div class="deeps">
              <div class="listded">
                {{ everydaylist.date }}
              </div>
              <ul
                class="table_item"
                v-for="(item, index) in noonToEvening"
                :key="index"
              >
                <li class="item">
                  <div class="amount">
                    <div class="iteml">{{ item.periodTime }}</div>
                  </div>
                  <span class="linet" style="color: #7A8294">{{
                    item.carNum
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from '@/components/mTitle.vue';
import mSelect from '@/components/mSelect.vue';
import * as echarts from 'echarts';
var color = ['#17B6A1', '#b0caf8', '#13D168', '#97f5c8', '#FE5A24', '#fcc5a9'];
export default {
  name: 'southcargo',
  inject: ['alertDialog'],
  data() {
    return {
      value: true,
      switchValue: false,
      switchText: '启用',
      listitem: [],
      astrictval: '进行中',
      selectastrict:[
        { label: "进行中", value: "0" },
        { label: "完成", value: "1" },
        { label: "暂停", value: "2" },
        { label: "作废", value: "3" },
      ],
      selectastrictt: [],
      selectinfo: '全部',
      changdisel:[
        { label: "前沿货场", value: "jiaotan" },
        { label: "港俊货场", value: "gangjun" },
        { label: "昊德", value: "haode" },
        { label: "琦晟", value: "qisheng" },
        { label: "睿鑫", value: "ruixin" },
        { label: "通达", value: "tongda" },
        { label: "富泉", value: "fuquan" },
      ],
      tablelist: [],
      everydaylist: {},
      morningToNoon: [],
      noonToEvening: [],
      zeroToMorning: [],
      timeout: null,
      lfoption: {
        grid: {
          // 直角坐标系内绘图网格
          left: '0', //grid 组件离容器左侧的距离,
          //left的值可以是80这样具体像素值，
          //也可以是'80%'这样相对于容器高度的百分比
          top: '0',
          right: '5%',
          bottom: '0',
          containLabel: true, //gid区域是否包含坐标轴的刻度标签。为true的时候，
          // left/right/top/bottom/width/height决定的是包括了坐标轴标签在内的
          //所有内容所形成的矩形的位置.常用于【防止标签溢出】的场景
        },
        tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'none'
        },
        formatter: function (params) {
            return params[0].name + '<br/>' +
                "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:rgba(36,207,233,0.9)'></span>" +
                params[0].seriesName + ' : ' + params[0].value +'辆'
        }
    },
        xAxis: {
          //直角坐标系grid中的x轴,
          //一般情况下单个grid组件最多只能放上下两个x轴,
          //多于两个x轴需要通过配置offset属性防止同个位置多个x轴的重叠。
          type: 'value', //坐标轴类型,分别有：
          //'value'-数值轴；'category'-类目轴;
          //'time'-时间轴;'log'-对数轴
          splitLine: { show: false }, //坐标轴在 grid 区域中的分隔线
          axisLabel: { show: false }, //坐标轴刻度标签
          axisTick: { show: false }, //坐标轴刻度
          axisLine: { show: false }, //坐标轴轴线
        },
        yAxis: {
          type: 'category',
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: {
            color: 'black',
            fontSize: 12,
          },
          data: ['已出场车辆','作业中车辆','待进场车辆','待申请进场',], //类目数据，在类目轴（type: 'category'）中有效。
          //如果没有设置 type，但是设置了axis.data,则认为type 是 'category'。
        },
        series: [
          //系列列表。每个系列通过 type 决定自己的图表类型
          {
            name: '', //系列名称
            type: 'bar', //柱状、条形图
            barWidth: 10, //柱条的宽度,默认自适应
            data: [20, 40, 60, 10], //系列中数据内容数组
            label: {
              //图形上的文本标签
              show: true,
              position: 'right', //标签的位置
              offset: [0, 0], //标签文字的偏移，此处表示向上偏移40
              formatter: '{c}{a}', //标签内容格式器 {a}-系列名,{b}-数据名,{c}-数据值
              color: 'black', //标签字体颜色
              fontSize: 12, //标签字号
            },
            itemStyle: {
              //图形样式
              normal: {
                //normal 图形在默认状态下的样式;
                //emphasis图形在高亮状态下的样式
                barBorderRadius: 10, //柱条圆角半径,单位px.
                //此处统一设置4个角的圆角大小;
                //也可以分开设置[10,10,10,10]顺时针左上、右上、右下、左下
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: '#22B6ED', //柱图渐变色起点颜色
                  },
                  {
                    offset: 1,
                    color: '#3FE279', //柱图渐变色终点颜色
                  },
                ]),
              },
            },
            zlevel: 1, //柱状图所有图形的 zlevel 值,
            //zlevel 大的 Canvas 会放在 zlevel 小的 Canvas 的上面
          },
          {
            name: '进度条背景',
            type: 'bar',
            barGap: '-100%', //不同系列的柱间距离，为百分比。
            // 在同一坐标系上，此属性会被多个 'bar' 系列共享。
            // 此属性应设置于此坐标系中最后一个 'bar' 系列上才会生效，
            //并且是对此坐标系中所有 'bar' 系列生效。
            barWidth: 10,
            data: [],
            color: '#EDEDED', //柱条颜色
            itemStyle: {
              normal: {
                barBorderRadius: 10,
              },
            },
          },
        ],
      },
      // 折线图
      option2: {
        color: ['#006DDC', '#17B6A1', '#5AE2FF'],
        legend: {
          left: 'right',
        },
        grid: {
          show: true,
          top: '15%',
          left: '2%',
          right: '5%',
          bottom: '3%',
          containLabel: true,
          borderWidth: 0,
          backgroundColor: '#F5F6FA',
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            fontSize: 13,
            fontFamily: 'Source Han Sans CN',
          },
          padding: [2, 10],
          borderWidth: 0,
          axisPointer: {
            lineStyle: {
              type: 'solid',
            },
          },
        },
        xAxis: [
          {
            type: 'category',
            position: 'bottom',
            axisTick: {
              show: false,
            },
            data: [
              '00:00-04:00',
              '04:00-08:00',
              '08:00-12:00',
              '12:00-16:00',
              '16:00-20:00',
              '20:00-24:00',
            ],
          },
        ],
        yAxis: {
          type: 'value',
          name:"单位：车次",
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
          splitLine: {
            show: true,
          },
        },
        series: [
          {
            name: '燃油车',
            data: [],
            type: 'line',
            symbol: 'circle',
            symbolSize: 9,
            showSymbol: false,
          },
          {
            name: '新能源车辆',
            data: [],
            type: 'line',
            symbol: 'circle',
            symbolSize: 9,
            showSymbol: false,
          },
          {
            name: '天然气车辆',
            data: [],
            type: 'line',
            symbol: 'circle',
            symbolSize: 9,
            showSymbol: false,
          },
        ],
      },

      selectitem: {
        page: 1, //当前页码
        limit: 8, //每页显示条数
        pno: '',
        stname: 'jiaotan',
        status: '0',
        customname: '',
      },
      carNum: '',
    };
  },
  watch: {
    $route: function(nval) {
      this.pagechange();
    },
  },
  components: {
    mTitle,
    mSelect,
  },
  created() {
    this.pagechange();
    // this.getselectastrict();
  },

  methods: {
    changdiselect(e){
      this.changdival=e
      this.selectitem.stname=e
      this.pagechange();
    },
  handleChange(item) {
      if (item.localhoststatus=='0') {
        this.callApiOnSwitchOn(item.id);
      } else if(item.localhoststatus=='2'){
        this.callApiOnSwitchOff(item.id);
      }
    },
     async callApiOnSwitchOn(id) {
      await this.$http(
        'api1',
        '/fleet/plan/planToSuspend',
        'post',
        { id: id }
      );
      this.getlist()
    },
    async callApiOnSwitchOff(id) {
       await this.$http(
        'api1',
        '/fleet/plan/planToStart',
        'post',
        { id: id }
      );
      this.getlist()
    },
    pagechange() {
      this.getlist();
      this.getcarlist();
      this.getcartimenumber();
      this.geteveryday();
      // this.gitsysdiclist();
      // this.callApiOnSwitchOn()
      // this.handleChange();
      // this.getselectastrict();
    },
    async getcarlist() {
      const { data } = await this.$http(
        'api1',
        '/driver/dispatchtruck/goodsYardStatusCarCount',
        'get',
        { goodsYard: this.selectitem.stname }
      );
      if (data.code != 0) return this.$message.error(data.msg);
      // 待申请进场
      this.lfoption.series[0].data[3] = data.data[0].toAuditCount;
      // 待进场
      this.lfoption.series[0].data[2] = data.data[0].toStayInCount;
      // 场内作业
      this.lfoption.series[0].data[1] = data.data[0].stayOutCount;
      // // 已出场车辆
      this.lfoption.series[0].data[0] = data.data[0].toOutCount;
      let maxnum=Math.max(...this.lfoption.series[0].data)
      this.lfoption.series[1].data=[]
      this.lfoption.series[0].data.forEach(item=>{
        this.lfoption.series[1].data.push(maxnum)
      })
      
      var ltopview = echarts.init(this.$refs.ltopview);
      ltopview.setOption(this.lfoption);
    },
    // 分时段车辆数
    async getcartimenumber() {
      const { data } = await this.$http(
        'api1',
        '/time/carnumber/getGoodsYardFourPeriodCarList',
        'get',
        { goodsyard: this.selectitem.stname }
      );
      // data.data;
      // console.log(data.data, this.changdival,'111');
      if (data.code != 0) return this.$message.error(data.msg);
      let xdata = [];
      let sdata = [];

      for (let i = 0; i < data.data.length; i++) {
        xdata = data.data[0].energyPeriodVo.map((item) => {
          return item.periodTime;
        });
        let obj = {
          name: '',
          data: [],
          type: 'line',
          symbol: 'circle',
          symbolSize: 9,
          showSymbol: false,
        };
        obj.name = data.data[i].name;
        obj.data = data.data[i].energyPeriodVo.map((item) => item.carNum);
        sdata.push(obj);
      }
      this.option2.xAxis[0].data = xdata;
      this.option2.series = sdata;
      var rtopview = echarts.init(this.$refs.rtopview);
      rtopview.setOption(this.option2);
    },
    // 计划列表
    async getlist() {
      const { data } = await this.$http(
        'api1',
        '/driver/dispatchtruck/goodsYardPlanList',
        'post',
        this.selectitem
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.tablelist = data;
    },
    // 每日派车数量
    async geteveryday() {
      const { data } = await this.$http(
        'api1',
        '/time/carnumber/goodsYardRecentCarCount',
        'get',
        { goodsyard: this.selectitem.stname }
      );
      // console.log(data, '每日派车数量');
      if (data.code != 0) return this.$message.error(data.msg);
      this.everydaylist = data.data;
      this.morningToNoon = data.data.morningToNoon;
      this.noonToEvening = data.data.noonToEvening;
      this.zeroToMorning = data.data.zeroToMorning;

      // console.log(this.morningToNoon, '列表');
    },
    // 查询
    selectlist() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.selectitem.page = 1;
        this.getlist();
      }, 300);
    },
    //重置
    reset(){
      this.selectitem.customname=""
      this.selectitem.pno=""
      this.selectitem.status="0"
      this.getlist();
    },
    // 作业垛位
    async gitsysdiclist() {
      const { data } = await this.$http(
        'api1',
        '/sys/dic/list',
        'get',
        { dictionaryType: '货场' }
        // { goodsyard: this.$route.params.name }
      );
      if (!data.data) return;
      this.selectastrictt = ['全部'];
      data.data.forEach((item) => {
        this.selectastrictt.push(item.val);
      });
      // console.log(data, 'sys/dic/list');
    },
    // 分页
    handleCurrentChange(index) {
      if (this.tablelist.planCount < this.selectitem.limit) return;
      this.selectitem.page = index;
      this.getlist();
    },
    // updown(obj) {
    //   let api = '/fleet/plan/planToSuspend';
    //   (info = '暂停成功'), (infomsg = '是否暂停');
    //   if (obj.localhoststatus === '2') {
    //     api = '/fleet/plan/planToStart';
    //     info = '启用成功';
    //     infomsg = '是否启用';
    //   }
    //   this.alertDialog(async (_) => {
    //     const { data } = await this.$http('api1', api, 'post', { id: obj.id });
    //     if (data.code != 0) return this.$message.error(data.msg);
    //     this.$message.success(info);
    //     this.getlist();
    //   });
    // },
    chanval(event) {
      this.astrictval = event;
      this.selectitem.status = this.selectastrict.indexOf(event);
      this.getlist();
    },
    jumpdetails(pno) {
      this.$router.push(`/cargo/cargolist/${pno}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.southcargo {
  position: relative;
  height: 100%;
  background-color: #f5f6fa;
  // margin-right: 20px;

  .chart_left1 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .xian {
    width: 12px;
    height: 26px;
    background: #17b6a1;
    border-radius: 6px;
    margin:  0 20px;
  }

  .ffcrgo_content {
    width: 100%;
    height: calc(100% - 50px);
    background: #f5f6fa;
    overflow: auto;
    padding: 10px;
    box-sizing: border-box;
    .changdi{
      width: 100%;
      height: 50px;
      background-color: #fff;
      margin-bottom: 10px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
      border-radius: 8px;
      .select_box {
        display: inline-block;
        font-weight: 400;
        width: 120px;
        height: 30px;
        vertical-align: middle;
        margin-left: 10px;
        // background: #f3f4f5;
        line-height: 30px;
      }
    }

    .ffcrgo_content_chart {
      height: 315px;
      // overflow: hidden;
      width: 100%;

      .chart_left,
      .chart_right {
        position: relative;
        height: 100%;
        background-color: #fff;
        border-radius: 20px;
        width: 50%;
        height:100%;
        .chart_left1{
          .title {
            box-sizing: border-box;
            height: 45px;
            line-height: 45px;
            font-size: 100%;;
            font-family: PingFang SC;
            font-weight: 600;
            color: #2D3748;
            // margin-top: 10px;
          }
        }
       
      }

      .chart_left {
        float: left;
        width: 44%;
        border-radius: 20px;
      }

      .chart_right {
        float: right;
        width: 55%;
        border-radius: 20px;
      }

      .chart_left_view,
      .chart_right_view {
        // position: absolute;
        // top: 65px;
        // left: 20px;
        // bottom: 0;
        height: 241px;
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
      }
    }

    .title {
      box-sizing: border-box;
      height: 45px;
      line-height: 45px;
      font-weight: bold;
      font-size: 100%;
      // margin-top: 10px;
    }

    .ffcrgo_content_list {
      margin-top: 10px;
      background-color: #fff;
      border-radius: 20px;
      width: 100%;
      .chart_left{
        width: 100%;
        height: 50px;
        .chart_left1{
          width: 100%;
          
          .xian{
            width: 12px;
            height: 26px;
            background: #17b6a1;
            border-radius: 6px;
            margin:  0 20px;
          }
          .title{
            box-sizing: border-box;
            height: 45px;
            line-height: 45px;
            font-weight: bold;
            font-size: 100%;
            // margin-top: 10px;
          }
        }
      }
      .list_title {
        position: relative;
        padding:0 10px;
        height: 45px;
        line-height: 45px;
        font-size: 14px;
        font-weight: bold;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .list_title_left{
            input {
            padding-left: 10px;
            width: 160px;
            height: 30px;
            outline: none;
            border: none;
            background: #f3f4f5;
            border-radius: 2px;
          }

          .select_box {
            display: inline-block;
            font-weight: 400;
            width: 88px;
            height: 30px;
            vertical-align: middle;
            margin-left: 10px;
            // background: #f3f4f5;
          }
        }
        .title-btn{
          display: flex;
          justify-content: flex-end;
          align-items: center;
            button {
              width: 80px;
            height: 30px;
            background: #17b6a1;
            border-radius: 8px;
           
            border: none;
            color: #fff;
            // margin-left: 13%;
          }

          .button1 {
            width: 80px;
            height: 30px;
            background: #f5f6fa;
            border-radius: 8px;
            border: none;
            color: #17b6a1;
            margin-left: 17px;
          }
        }
        

        
      }

      .paging {
        text-align: center;
        padding-bottom: 20px;
      }

      .list_content {
        border-top: 1px solid #f3f4f5;
        box-sizing: border-box;
        background: #eff1f6;
        overflow: auto;
        margin: 30px;

        .ulbox {
          box-sizing: border-box;
          width: 100%;
          list-style: none;
          // padding-left: ;
          padding: 10px;
          margin: 0;
          display: flex;
          flex-wrap: wrap;
          justify-content:flex-start;
          .item_style {
            // float: left;
            position: relative;
            box-sizing: border-box;
            width: 23%;
            // height: 358px;
            // padding: 23px;
            // box-sizing: border-box;
            border-radius: 20px;
            margin-left: 18px;
            background-color: #f8f9fb;
            margin-top: 16px;

            .swipers {
              height: 70px;
              box-sizing: border-box;
              background: #ffffff;
              border-radius: 8px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              // line-height: 60px;
              font-size: 90%;
              font-family: PingFang SC;
              padding: 0 22px;
              box-sizing: border-box;
              .swiperleft{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .inquire {
                  font-weight: 600;
                  color: #333333;
                }

                .point {
                  margin-left: 8px;
                  font-weight: 400;
                  color: #17b6a1;
                }
              }
              .strabs {
                // position: absolute;
                // z-index: 1;
                cursor: pointer;
                // right: 10px;
                // top: 22px;
              }
              
            }

            
            .list-content{
              height: 288px;
              padding: 23px;
              box-sizing: border-box;
              .divbox {
              margin: 13px 23px;
              .box_title {
                .status_circle {
                  display: inline-block;
                  width: 6px;
                  height: 6px;
                  border-radius: 100%;
                  margin-right: 5px;
                  vertical-align: middle;
                }
              }
            }
            }
            .iconfont {
              position: absolute;
              z-index: 999;
              cursor: pointer;
              right: 10px;
              top: 10px;
            }

            .icon-qiyong {
              color: #13d4b4;
            }

            

            ul {
              list-style: none;
              height: 25%;
              width: 100%;
              padding: 0;
              margin: 0;

              li {
                float: left;
                height: 100%;
                width: 33.3%;

                .span {
                  font-size: 33px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  color: #666666;
                  display: block;
                  text-align: center;
                  margin: 0 auto;
                }

                .span1 {
                  display: block;
                  text-align: center;
                  margin: 0 auto;
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  color: #7a8294;
                }
              }
            }
          }

          .kx {
            height: 5%;
          }

          .botline {
            height: 5%;

            span {
              float: left;
              display: block;
            }

            .baritemline {
              display: inline-block;
              height: 100%;
              width: 100%;
              background: red;
            }
          }

          & .item_style:first-of-type {
            border-left: none;
          }
        }

        & .ulbox:first-of-type .item_style {
          border-top: none;
        }
      }
    }

    .ffcrgo_content_table {
      margin-top: 15px;
      // width: 1632px;
      background-color: #fff;
      border-radius: 20px;
 

      .title {
        box-sizing: border-box;
        padding-left: 10px;
        height: 45px;
        line-height: 45px;
        font-size: 100%;
        font-weight: bold;
      }

      .content_table_list {
        overflow: auto;
        .itemsdev {
          width: 100%;
          display: flex;
          justify-content: space-evenly;
          .deeps {
            width: 286px;
            margin-left: 28px;
            .listded {
              text-align: center;
            }
          }
          .table_item {
            // width: 19.5%;
            padding: 0;
            list-style: none;
            .first {
              height: 35px;
              text-align: center;
              line-height: 35px;
              font-size: 80%;
              font-weight: bold;
            }
            .item {
              box-sizing: border-box;
              padding-right: 20px;
              height: 30px;
              width: 85%;
              line-height: 30px;
              font-size: 80%;
              text-align: center;
              display: flex;
              justify-content: space-between;
              background: #f8f9fb;
              border-radius: 13px;
              margin: 4px 53px;
              .iteml {
                float: left;
              }
              .amount {
                width: 75%;
                padding-right: 27px;
                padding-left: 20px;
                background-color: #dff6f4;
                border-radius: 13px;
                display: flex;
                justify-content: space-between;
              }
              .itemr {
                float: right;
                position: relative;
                height: 100%;
                width: 30%;
                .line {
                  position: absolute;
                  left: 50%;
                  transform: translateX(-50%);
                }
                .linet {
                  margin: 0 5px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
